<lib-dba-mat-dialog-title (cancelClick)="dialogRef.close()">
  {{Title}}
</lib-dba-mat-dialog-title>

<mat-dialog-content [formGroup]="FormGroup">
  @if(loading){<lib-spinner-dialog></lib-spinner-dialog>}

  <div class="row">
    <mat-form-field>
      <mat-label>{{language.Nummer | translationPipe}}</mat-label>
      <input matInput maxlength="20" formControlName="nummerControl">
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{language.Name | translationPipe}}</mat-label>
      <input matInput maxlength="100" formControlName="nameControl">
    </mat-form-field>
  </div>

  <mat-form-field>
    <mat-label>{{language.Strasse | translationPipe}}</mat-label>
    <input matInput maxlength="100" formControlName="strasseControl">
  </mat-form-field>

  <div class="row">
    <mat-form-field>
      <mat-label>{{language.PLZ | translationPipe}}</mat-label>
      <input matInput maxlength="7" formControlName="plzControl">
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{language.Ort | translationPipe}}</mat-label>
      <input matInput maxlength="100" formControlName="ortControl">
      <mat-icon *ngIf="this.OrtControl.value!='' && this.PLZControl.value!='' && this.StrasseControl.value!=''"
        (click)="openMaps()" matSuffix>public</mat-icon>
    </mat-form-field>
  </div>

  <lib-select-create formControlName="landControl" [selectList]="landList" selectValue="LandID" selectName="LandName"
    [label]="language.Land | translationPipe" [showDeselect]="false" [showCreate]="false">
  </lib-select-create>

  <div class="row">
    <mat-form-field>
      <mat-label>{{language.Tel | translationPipe}}</mat-label>
      <input matInput maxlength="20" formControlName="telefonControl">
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{language.EMail | translationPipe}}</mat-label>
      <input matInput maxlength="100" formControlName="emailControl">
      <mat-icon matSuffix (click)="OnMailClick()">mail</mat-icon>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <lib-dba-mat-dialog-footer (cancelClick)="dialogRef.close()" (saveClick)="Save()"></lib-dba-mat-dialog-footer>
</mat-dialog-actions>